module.exports = {
	"data": {
		"site": {
			"siteMetadata": {
				"title": "React Gravatar"
			}
		}
	},
	"pathContext": {
		"component": "/Users/kylemathews/programs/react-gravatar/www/pages/index.js",
		"path": "/"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../.intermediate-representation/json/1584451144.json
 ** module id = 212
 ** module chunks = 3
 **/